import React from 'react';
import './semantic-query-card.scss';
import { TouchableOpacity } from '../../../common';
import { ReactComponent as ArrowRightIcon } from '@zonofi/svg-icons/arrow_right.svg';
import { Divider } from '../../../components';
import { ConversationQueryType } from '@zonofi/zono-money-store';

const SAFE_ICON_REGEX = /^[a-z0-9-]+$/;
export function getSafeIcon(icon: string): string {
  if (!icon) return 'question';
  return SAFE_ICON_REGEX.test(icon) ? icon : 'question';
}

export interface SemanticQueryCardProps {
  query: ConversationQueryType;
  onPress?: (query: ConversationQueryType) => void;
  showDivider?: boolean;
  hideArrow?: boolean;
}

export const SemanticQueryCard: React.FC<SemanticQueryCardProps> = ({
  query,
  onPress = () => {},
  showDivider = false,
  hideArrow = false,
}) => {
  const iconColor = query?.color || '#9CA3AF';
  const totalThreads = query?.conversationThreads?.pagination?.total;

  return (
    <div className="semantic-query__item">
      <TouchableOpacity
        className="semantic-query-card"
        onPress={() => onPress?.(query)}
      >
        {/* Icon */}
        <div
          className="semantic-query-card__icon-wrapper"
          style={{ backgroundColor: `${iconColor}1f` }}
        >
          <i
            className={`fa-solid fa-${getSafeIcon(query?.icon)} semantic-query-card__icon`}
            style={{ color: iconColor }}
            aria-hidden
          />
        </div>

        {/* Content */}
        <div className="semantic-query-card__content">
          <div className="semantic-query-card__title font-semibold">
            {query?.queryType}
          </div>
          <div className="semantic-query-card__description font-regular">
            {query?.description}
          </div>
          {totalThreads !== undefined && (
            <div className="semantic-query-card__thread-count font-semibold">
              {`@ ${totalThreads} THREADS`}
            </div>
          )}
        </div>

        {/* Arrow */}
        {!hideArrow && (
          <div>
            <ArrowRightIcon
              width={20}
              height={20}
              color="#8C8C8C"
              style={{ marginRight: '6px' }}
            />
          </div>
        )}
      </TouchableOpacity>

      {showDivider && <Divider className="semantic-query__divider" />}
    </div>
  );
};
